<template>
  <div class="AllPwaMobile">
    <div id="frame">
      <div
        style="grid-template-columns: auto"
        class="ShowBackToSiteProfileGet2"
      >
        <perfect-scrollbar
          style="
            margin-bottom: 10px;
            position: relative !important;
            margin-top: 10px;
          "
          class="ShowOfferToMe"
        >
          <div
            @click="GetValueShow(templates)"
            v-for="(templates, index) in chat_defult"
            style="background: #f5f5f5"
            :key="index"
            class="ChildShowOfferToMe"
          >
            {{ templates }}
          </div>
        </perfect-scrollbar>
      </div>
      <div class="content">
        <PerfectScrollbar ref="scrollContainer" class="messages">
          <ul v-if="!loading">
            <li
              v-for="(MessagesLists, index) in MessagesList"
              :key="index"
              :class="MessagesLists.owner == 'me' ? 'replies' : 'sent'"
            >
              <img
                v-if="MessagesLists.owner == 'me'"
                :src="MessagesLists.avatar"
                alt="{{MessagesLists.nickname}}"
              />
              <p v-if="MessagesLists.content_type == 'text'">
                {{ MessagesLists.content }}
              </p>

              <Vue3WaveAudioPlayer
                v-if="MessagesLists.content_type == 'voice'"
                :wave_width="100"
                :wave_height="40"
                wave_type="mirror"
                :src="MessagesLists.file_name"
                @on_error="handleError"
                @on_ended="handleEnded"
              />

              <img
                v-if="MessagesLists.owner != 'me'"
                :src="MessagesLists.avatar"
                alt="{{MessagesLists.nickname}}"
              />

              <div
                :style="
                  MessagesLists.owner == 'me' ? ' right: 35px' : 'left:35px;'
                "
                class="ShowToUserText"
              >
                <div>{{ separatedDate(MessagesLists.created_at_fa)[0] }}</div>
                <div>{{ separatedDate(MessagesLists.created_at_fa)[1] }}</div>
                <div>{{ separatedDate(MessagesLists.created_at_fa)[2] }}</div>
              </div>
            </li>
          </ul>

          <div id="getScroll"></div>
        </PerfectScrollbar>

        <div v-if="loading" class="ShowAllLoadingIf">
          <!-- <div class="dotted-loader"></div> -->
          <div class="sk-cube-grid">
            <div class="sk-cube sk-cube1"></div>
            <div class="sk-cube sk-cube2"></div>
            <div class="sk-cube sk-cube3"></div>
            <div class="sk-cube sk-cube4"></div>
            <div class="sk-cube sk-cube5"></div>
            <div class="sk-cube sk-cube6"></div>
            <div class="sk-cube sk-cube7"></div>
            <div class="sk-cube sk-cube8"></div>
            <div class="sk-cube sk-cube9"></div>
          </div>
        </div>

        <div class="message-input">
          <div class="ShowToUserVoiceAndDelete" v-if="isRecording1">
            <div>
              <div class="DeleteShowToUserGet">
                <VsxIcon
                  @click="DeleteGarbage"
                  iconName="Trash"
                  :size="32"
                  color="#5584FF"
                  type="linear"
                />
              </div>
            </div>

            <div class="ShowWaveformClass">
              <p v-if="isRecording == 2">
                {{ minutes }}:{{ seconds < 10 ? "0" + seconds : seconds }}
              </p>

              <div id="waveform"></div>

              <div v-if="isRecording == 3">
                <button v-if="playSelect == 1" class="PlayButton" @click="play">
                  <VsxIcon
                    iconName="Play"
                    :size="32"
                    color="#435f7a"
                    type="linear"
                  />
                </button>
                <button
                  v-if="playSelect == 2"
                  class="StopButton"
                  @click="pause"
                >
                  <VsxIcon
                    iconName="Pause"
                    :size="30"
                    color="red"
                    type="linear"
                  />
                </button>
              </div>
            </div>
          </div>

          <!--          <button @click="downloadAudio">ذخیره صدا</button>-->

          <input
            type="text"
            v-if="!isRecording1"
            v-model="message"
            @input="autoResize"
            class="custom-textarea"
            placeholder="متن خود را اینجا وارد کنید..."
            ref="autoResizeTextarea"
          />

          <div>
            <!--            ================ send text =======================-->
            <div v-if="message != ''" class="DivButtonTextMessage">
              <div class="IconSentMessage sendIcon" @click="send_pm()">
                <!-- <VsxIcon iconName="Send" :size="32" color="#5584FF" type="linear" /> -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                  <path
                    d="M568.4 37.7C578.2 34.2 589 36.7 596.4 44C603.8 51.3 606.2 62.2 602.7 72L424.7 568.9C419.7 582.8 406.6 592 391.9 592C377.7 592 364.9 583.4 359.6 570.3L295.4 412.3C290.9 401.3 292.9 388.7 300.6 379.7L395.1 267.3C400.2 261.2 399.8 252.3 394.2 246.7C388.6 241.1 379.6 240.7 373.6 245.8L261.2 340.1C252.1 347.7 239.6 349.7 228.6 345.3L70.1 280.8C57 275.5 48.4 262.7 48.4 248.5C48.4 233.8 57.6 220.7 71.5 215.7L568.4 37.7z"
                  />
                </svg>
              </div>
            </div>

            <!--            ================ send voice =======================-->

            <div v-if="message == ''" class="DivButtonTextMessage">
              <div
                @click="startRecording"
                v-if="isRecording == 1"
                class="IconSentMessage1"
              >
                <!-- <VsxIcon iconName="Microphone2" :size="32" color="#5584FF" type="linear" /> -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="size-6"
                >
                  <path
                    d="M8.25 4.5a3.75 3.75 0 1 1 7.5 0v8.25a3.75 3.75 0 1 1-7.5 0V4.5Z"
                  />
                  <path
                    d="M6 10.5a.75.75 0 0 1 .75.75v1.5a5.25 5.25 0 1 0 10.5 0v-1.5a.75.75 0 0 1 1.5 0v1.5a6.751 6.751 0 0 1-6 6.709v2.291h3a.75.75 0 0 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5h3v-2.291a6.751 6.751 0 0 1-6-6.709v-1.5A.75.75 0 0 1 6 10.5Z"
                  />
                </svg>
              </div>

              <div
                @click="stopRecording"
                v-if="isRecording == 2"
                class="DeleteShowToUserGet"
              >
                <!-- <VsxIcon iconName="Stop" :size="32" color="#5584FF" type="linear" /> -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="size-6"
                >
                  <path
                    fill-rule="evenodd"
                    d="M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>

              <div
                @click="UploadVoice"
                v-if="isRecording == 3"
                class="DeleteShowToUserGet1 sendIcon"
              >
                <!-- <VsxIcon iconName="Send" :size="32" color="#5584FF" type="linear" /> -->
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
                  <path
                    d="M568.4 37.7C578.2 34.2 589 36.7 596.4 44C603.8 51.3 606.2 62.2 602.7 72L424.7 568.9C419.7 582.8 406.6 592 391.9 592C377.7 592 364.9 583.4 359.6 570.3L295.4 412.3C290.9 401.3 292.9 388.7 300.6 379.7L395.1 267.3C400.2 261.2 399.8 252.3 394.2 246.7C388.6 241.1 379.6 240.7 373.6 245.8L261.2 340.1C252.1 347.7 239.6 349.7 228.6 345.3L70.1 280.8C57 275.5 48.4 262.7 48.4 248.5C48.4 233.8 57.6 220.7 71.5 215.7L568.4 37.7z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
// import WaveSurfer from 'wavesurfer.js';
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import Vue3WaveAudioPlayer from "vue3-wave-audio-player";
import { mapGetters } from "vuex";
// import { VoiceRecorder } from "capacitor-voice-recorder";
import axios from "axios";
export default {
  components: {
    PerfectScrollbar,
    Vue3WaveAudioPlayer,
  },
  name: "MessageUser",
  computed: {
    ...mapGetters(["auth_taxi", "taxi_c_set"]),
  },
  props: {
    ServiceData: Object,
  },
  watch: {
    ServiceData: {
      handler(newVal) {
        console.log("ServiceData:" + newVal);
      },
    },
  },
  data() {
    return {
      playSelect: 1,
      message: "",
      recorder: null,
      isRecording: 1,
      isRecording1: false,
      audioURL: null,
      wavesurfer: null,
      loading: true,
      totalSeconds: 0,
      timer: null,
      minutes: 0,
      seconds: 0,
      MessagesList: [],
      chat_defult: [],
      interval: null,
    };
  },
  mounted() {
    let self = this;
    self.getInfo();
    this.chat_defult = this.taxi_c_set.chat_defult;
    this.interval = setInterval(() => {
      let self = this;
      self.ReloadPage("scroll");
    }, 5000);
  },
  methods: {
    handleError(error) {
      console.error("Error occurred while playing audio:", error);
    },
    handleEnded() {
      console.log("Audio playback ended.");
    },

    separatedDate(dateTime) {
      const [datePart, timePart] = dateTime.split(" - ");
      const day = datePart.split(", ")[0];
      const monthYear = datePart.split(", ")[1];
      const time = timePart.split(":").slice(0, 2).join(":");
      return [day, monthYear, time];
    },

    scroll(e) {
      if (!this.loadmore) {
        return;
      }
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) ==
        target.offsetHeight - target.scrollHeight
      ) {
        this.ReloadPage("scroll");
      }
    },
    clearMessage() {
      this.message = "";
    },
    getInfo() {
      let self = this;
      self.ReloadPage();
    },
    ReloadPage(state) {
      let self = this;
      self.checkmsg();
      if (state === "scroll") {
        self.PageShow += 1;
        console.log("sc");
      } else {
        self.MessagesList = [];
        self.PageShow = 1;
      }
      self
        .helperGet_taxi(
          "chat-list",
          "type=passanger" +
            "&uid=" +
            self.auth_taxi.uid +
            "&receiver_id=" +
            self.ServiceData.driver_id +
            "&service_id=" +
            self.ServiceData.service_id +
            "&page=1"
        )
        .then((json) => {
          this.loading = false;
          if (json.data.result == "0") {
            self.PageShow -= 1;
          } else if (json.data.result == "1") {
            self.MessagesList = json.data.data.list;
            this.scrollToBottom();
          }
          self.tem_load = !self.tem_load;
        });
    },
    checkmsg() {
      let self = this;
      self
        .helperGet_taxi(
          "check-message",
          "uid=" +
            self.auth_taxi.uid +
            "&service_id=" +
            self.ServiceData.service_id
        )
        .then((json) => {
          console.log("ss", json);
        });
    },
    send_pm() {
      let self = this;
      this.loading = true;
      let newParam = {};
      newParam.message = this.message;
      newParam.uid = this.auth_taxi.uid;
      newParam.service_id = this.ServiceData.service_id;
      newParam.receiver_id = this.ServiceData.driver_id;
      this.helperPost_taxi("chat-insert", newParam)
        .then(function (r) {
          if (r.data.result === "1") {
            self.ReloadPage();
            self.message = "";
          }
          self.loading = false;
        })
        .catch(function () {
          self.loading = false;
        });
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer.$el;
        if (container) {
          container.scrollTo(0, container.scrollHeight);
        }
      });
    },

    autoResize() {
      const textarea = this.$refs.autoResizeTextarea;
      textarea.style.height = "40px";
      const newHeight = textarea.scrollHeight;
      textarea.style.height = Math.min(newHeight, 100) + "px";
    },

    startTimer() {
      if (this.timer) return;
      this.timer = setInterval(() => {
        this.totalSeconds++;
        this.minutes = Math.floor(this.totalSeconds / 60);
        this.seconds = this.totalSeconds % 60;
      }, 1000);
    },

    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    resetTimer() {
      this.stopTimer();
      this.totalSeconds = 0;
      this.minutes = 0;
      this.seconds = 0;
    },

    DeleteGarbage() {
      this.pause();
      this.isRecording1 = false;
      this.isRecording = 1;
    },

    play() {
      if (this.wavesurfer) {
        this.wavesurfer.play();
        this.playSelect = 2;
      }
    },
    pause() {
      if (this.wavesurfer) {
        this.wavesurfer.pause();
        this.playSelect = 1;
      }
    },

    // async checkPermission() {
    //   const permission = await VoiceRecorder.requestAudioRecordingPermission();
    //   if (!permission.value) {
    //     toast.error('شما مجوز دسترسی به میکرفون را ندارید');
    //     return false;
    //   }
    //   return true;
    // },

    // async startRecording() {
    //   try {
    //     const hasPermission = await this.checkPermission();
    //     if (!hasPermission) return;
    //
    //     await VoiceRecorder.startRecording();
    //     this.isRecording1 = true;
    //     this.isRecording = 2;
    //     this.resetTimer();
    //     this.startTimer();
    //   } catch (error) {
    //     toast.error("برای ضبط صدا، دسترسی به میکروفن لازم است.", {
    //       autoClose: 3000,
    //       position: "top-right",
    //       type: "error",
    //     });
    //   }
    // },
    // async stopRecording() {
    //   const result = await VoiceRecorder.stopRecording();
    //
    //   if (result.value && result.value.recordDataBase64) {
    //     const audioBlob = this.base64ToBlob(result.value.recordDataBase64, result.value.mimeType);
    //     this.audioURL = URL.createObjectURL(audioBlob);
    //     this.isRecording = 3;
    //     this.stopTimer();
    //
    //     if (this.wavesurfer) {
    //       this.wavesurfer.destroy();
    //     }
    //     this.wavesurfer = WaveSurfer.create({
    //       container: '#waveform',
    //       waveColor: '#435f7a',
    //       progressColor: '#24425e',
    //       barWidth: 3,
    //       barHeight: 1,
    //       barGap: 2,
    //       height: 35,
    //     });
    //
    //     this.wavesurfer.load(this.audioURL);
    //   } else {
    //     console.warn('Failed to get audio data.');
    //   }
    // },
    async UploadVoice() {
      let self = this;
      self.loading = true;
      this.pause();
      this.resetTimer();
      if (this.audioURL) {
        const formData = new FormData();
        const audioBlob = await fetch(this.audioURL).then((res) => res.blob());
        formData.append("voice", audioBlob, "recorded-audio.wav");
        formData.append("uid", this.auth_taxi.uid);
        formData.append("customer_id", this.ServiceData.driver_id);
        formData.append("service_id", this.ServiceData.service_id);
        axios
          .post(
            self.$store.getters.baseUrl_taxi + "/chat-insert-voice",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + self.$store.getters.appToken_taxi,
              },
            }
          )
          .then(function (response) {
            console.log("response", response);
            if (response.data.result == "1") {
              self.ReloadPage();
              self.message = "";
              self.ShowModel = false;
              self.loading = false;
            } else {
              toast("اشکال در ثبت رخ داد!دوباره تلاش کنید", {
                type: "error",
                dangerouslyHTMLString: true,
              });
              self.loading = false;
            }
          });
      }
      this.isRecording1 = false;
      this.isRecording = 1;
    },
    base64ToBlob(base64, mimeType) {
      const byteCharacters = atob(base64);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      return new Blob(byteArrays, { type: mimeType });
    },

    GetValueShow(value) {
      this.message = value;
      this.send_pm();
    },
    downloadAudio() {
      this.pause();
      this.resetTimer();
      if (this.audioURL) {
        const link = document.createElement("a");
        link.href = this.audioURL;
        link.download = "recorded-audio.wav";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      this.isRecording1 = false;
      this.isRecording = 1;
    },
    clearMethod() {
      clearInterval(this.interval);
    },
  },

  beforeRouteLeave() {
    if (this.wavesurfer) {
      this.wavesurfer.destroy();
      this.wavesurfer = null;
    }
  },
};
</script>

<style scoped lang="scss">
.messages {
  bottom: 150px;
}

.messages {
  bottom: 85px;
}

.ShowBackToSiteProfileGet2 {
  direction: rtl;
  background: transparent !important;
  bottom: 70px !important;
  .ShowOfferToMe {
    width: 100% !important;
  }
  .ChildShowOfferToMe {
    padding: 8px 16px !important;
    background: rgba(8, 81, 160, 0.15) !important;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0851a0 !important;
    border-radius: 9999px !important;
    transition: all 0.15s;
    &:active {
      transform: scale(0.9);
    }
  }
}

.light {
  .message-input {
    height: 112px !important;
    padding: 68px 16px 0;
    width: 100% !important;
    box-shadow: 0 -3px 4px rgba(0, 0, 0, 0.2);
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;

    .custom-textarea {
      flex-grow: 1;
      border-radius: 10px !important;
      padding: 12px !important;
      font-size: 0.9rem !important;
      transition: all 0.25s;
      height: 44px !important;
      background: #f7f7f7 !important;
      border: 1px solid #dedede !important;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15) !important;
      direction: rtl;
      text-align: right;

      &:focus {
        background: #fff !important;
      }
    }

    .DivButtonTextMessage {
      flex-shrink: 0 !important;
      width: 44px !important;
      height: 44px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      background: rgb(8, 81, 160) !important;
      border-radius: 10px !important;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15) !important;

      .IconSentMessage1,
      .IconSentMessage,
      .DeleteShowToUserGet,
      .DeleteShowToUserGet1 {
        position: static !important;
        color: #fff;
        width: 24px;
        height: 24px;

        svg {
          width: 24px;
          height: 24px;
          transform: rotate(0) !important;
        }
      }

      .IconSentMessage,
      .DeleteShowToUserGet1 {
        svg {
          fill: #fff;
        }
      }
    }
  }
}
.light #frame .content .messages ul li.replies p {
  background: #34be73 !important;
}

.light .ShowAllLoadingIf {
  background: #ffff !important;
  bottom: 132px !important;
  z-index: 98 !important;
}

.sk-cube-grid {
  width: 40px;
  height: 40px;
  margin: 100px auto;
}

.sk-cube-grid .sk-cube {
  width: 33%;
  height: 33%;
  background-color: #0851a0;
  float: left;
  -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
  animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
}
.sk-cube-grid .sk-cube1 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
.sk-cube-grid .sk-cube2 {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.sk-cube-grid .sk-cube3 {
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}
.sk-cube-grid .sk-cube4 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}
.sk-cube-grid .sk-cube5 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
.sk-cube-grid .sk-cube6 {
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
}
.sk-cube-grid .sk-cube7 {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}
.sk-cube-grid .sk-cube8 {
  -webkit-animation-delay: 0.1s;
  animation-delay: 0.1s;
}
.sk-cube-grid .sk-cube9 {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

@-webkit-keyframes sk-cubeGridScaleDelay {
  0%,
  70%,
  100% {
    -webkit-transform: scale3D(1, 1, 1);
    transform: scale3D(1, 1, 1);
  }
  35% {
    -webkit-transform: scale3D(0, 0, 1);
    transform: scale3D(0, 0, 1);
  }
}

@keyframes sk-cubeGridScaleDelay {
  0%,
  70%,
  100% {
    -webkit-transform: scale3D(1, 1, 1);
    transform: scale3D(1, 1, 1);
  }
  35% {
    -webkit-transform: scale3D(0, 0, 1);
    transform: scale3D(0, 0, 1);
  }
}
</style>
